// extracted by mini-css-extract-plugin
module.exports = {"chartcontainer":"Chart_chartcontainer__7yyeZ","chart":"Chart_chart__CIm5h","chartBorder":"Chart_chartBorder__8L_jY"};